
define('modules/application/wizard/steps/regularStep',[
  "app",

  // Libs
  "backbone",
  "jqueryUi",

  //Class
  "../classes/accessoryLine",

  //Thermoregulation
  "../classes/mainControlUnit",
  "../classes/genericIncrementalElement",
  "../classes/outerRadioProbe",
  "../classes/pumps",
  "../classes/solenoidValves",
  "../classes/probes",
  "../classes/ecoMode",
  "../classes/series",
  "../classes/exportElement",
  "../classes/exportMaterialList",
  "../classes/exportProjectConfiguration",
  "../classes/exportProjectFile",

  //Intrusion detection
  "../classes/kits/intrusionDetectionKits",
  "../classes/powerSupply",
  "../classes/powerSupplyWithSirens",
  "../classes/intrusionDetectionMainControlUnit",
  "../classes/mainControlUnitWithRemoteControls",
  "../classes/sirens",
  "../classes/remoteControls",
  "../classes/radioSystems",
  "../classes/inserters",
  "../classes/deinserters",

  //Audio video
  "../classes/audioVideoSystemSelectionAndPowerSupply",
  "../classes/vdeExpansion",
  "../classes/busExpansion",

  //Automation
  "../classes/automationSystemSelection",
  "../classes/automationSimpleSystemSelection",
  "../classes/energyManagementSystemSelection",
  "../classes/mainBus",
  "../classes/logicAreas",
  "../classes/advancedCommands",
  "../classes/zigbeeRadio",
  "../classes/automationRemoteControls",
  "../classes/integrationDevices",
  "../classes/kits/automationKits",
  "../classes/kits/automationSimpleKits",
  "../classes/kits/energyManagementKits",

  //Plugins
  "plugins/customFormElement",
  "plugins/jquery-multiaccordion",
  "plugins/jquery-corner",
  "plugins/jquery-mousewheel",
  "plugins/jquery-mCustomScrollbar",
  "plugins/jquery-touchpunch",
  "plugins/cssua"
],

function(
  app,
  Backbone,
  jQueryUi,
  accessoryLine,
  mainControlUnit,
  genericIncrementalElement,
  outerRadioProbe,
  pumps,
  solenoidValves,
  probes,
  ecoMode,
  series,
  exportElement,
  exportMaterialList,
  exportProjectConfiguration,
  exportProjectFile,
  intrusionDetectionKits,
  powerSupply,
  powerSupplyWithSirens,
  intrusionDetectionMainControlUnit,
  mainControlUnitWithRemoteControls,
  sirens,
  remoteControls,
  radioSystems,
  inserters,
  deinserters,
  audioVideoSystemSelectionAndPowerSupply,
  vdeExpansion,
  busExpansion,
  automationSystemSelection,
  automationSimpleSystemSelection,
  energyManagementSystemSelection,
  mainBus,
  logicAreas,
  advancedCommands,
  zigbeeRadio,
  automationRemoteControls,
  integrationDevices,
  automationKits,
  automationSimpleKits,
  energyManagementKits) {

  var RegularStep = app.module();
  _.extend(RegularStep, {

    objClass            : "regular",
    Model               : Backbone.Model,

    Views               : {

      Tab         : Backbone.View.extend({
        template      : "application/wizard/steps/tabs-item",
        tagName       : "li",
        keep          : true,

        serialize : function() {
          return { model: this.model };
        },

        cleanup   : function() {
          this.model.off(null, null, this);
        }
      }),

      Confirm     : Backbone.View.extend({
        keep           : true,
        template       : "application/wizard/steps/confirm",
        tagName        : "footer",

        serialize: function() {
          return { model: this.model };
        },

        cleanup: function() {
          this.model.off(null, null, this);
        }

      }),

      Content      : Backbone.View.extend({
        keep         : true,
        template     : "application/wizard/steps/regular",
        className    : "tab itemView",

        initialize   : function()        {
          var that                = this,
              sections            = this.options.model.get("sections"),
              stepEventAggregator = this.options.stepEventAggregator,
              sectionsLength      = sections ? sections.length : 0,
              i                   = 0,
              classToInstance,
              obj;

          for(i=0;i<sectionsLength;i++)
          {
            //Retrieve the correct class to instance
            classToInstance = this.sectionInstancer(sections[i]);
            obj             = classToInstance;

            //Instance the section's model
            if (sections[i].idWizardChoice)
            {
              objModel  = new obj.Model({
                stepEventAggregator :   stepEventAggregator,
                idWizardChoice      :   sections[i].idWizardChoice
              });
            }
            else
            {
              objModel  = new obj.Model({
                stepEventAggregator :   stepEventAggregator
              });
            }

            //Insert the section's views into the main accordion view
            this.insertView(".accordionView", new obj.Views.titleBar ({ model   :   objModel  }));
            this.insertView(".accordionView", new obj.Views.content  ({ model   :   objModel  }));
          }
        },

        showUnvalidationAlert : function() {
        },

        sectionInstancer   : function(section) {
          switch(section.name)
          {
          case "accessoryLine"                          :
            return accessoryLine;
          case "mainControlUnit"                        :
            return mainControlUnit;
          case "outerRadioProbe"                        :
            return outerRadioProbe;
          case "pumps"                                  :
            return pumps;
          case "solenoidValves"                         :
            return solenoidValves;
          case "probes"                                 :
            return probes;
          case "ecoMode"                                :
            return ecoMode;
          case "series"                                 :
            return series;
          case "exportElement"                          :
            return exportElement;
          case "exportProjectConfiguration"             :
            return exportProjectConfiguration;
          case "exportProjectFile"                      :
            return exportProjectFile;
          case "exportMaterialList"                     :
            return exportMaterialList;
          case "intrusionDetectionExportMaterialList"   :
            return intrusionDetectionExportMaterialList;
          case "powerSupply"                            :
            return powerSupply;
          case "powerSupplyWithSirens"                  :
            return powerSupplyWithSirens;
          case "intrusionDetectionMainControlUnit"      :
            return intrusionDetectionMainControlUnit;
          case "mainControlUnitWithRemoteControls"      :
            return mainControlUnitWithRemoteControls;
          case "sirens"                                 :
            return sirens;
          case "remoteControls"                         :
            return remoteControls;
          case "radioSystems"                           :
            return radioSystems;
          case "intrusionDetectionKits"                 :
            return intrusionDetectionKits;
          case "inserters"                              :
            return inserters;
          case "deinserters"                            :
            return deinserters;
          case "audioVideoSystemSelectionAndPowerSupply":
            return audioVideoSystemSelectionAndPowerSupply;
          case "vdeExpansion"                           :
            return vdeExpansion;
          case "busExpansion"                           :
            return busExpansion;
          case "audioVideoExportMaterialList"           :
            return audioVideoExportMaterialList;
          case "automationSystemSelection"              :
            return automationSystemSelection;
          case "automationSimpleSystemSelection"        :
            return automationSimpleSystemSelection;
          case "energyManagementSystemSelection"        :
            return energyManagementSystemSelection;
          case "mainBus"                                :
            return mainBus;
          case "logicAreas"                             :
            return logicAreas;
          case "advancedCommands"                       :
            return advancedCommands;
          case "zigbeeRadio"                            :
            return zigbeeRadio;
          case "automationRemoteControls"               :
            return automationRemoteControls;
          case "integrationDevices"                     :
            return integrationDevices;
          case "automationExportMaterialList"           :
            return automationExportMaterialList;
          case "automationKits"                         :
            return automationKits;
          case "automationSimpleKits"                   :
            return automationSimpleKits;
          case "energyManagementKits"                   :
            return energyManagementKits;
          }
        },

        serialize    : function()       {
          return { model: this.model };
        },

        cleanup      : function()       {
          this.model.off(null, null, this);
        },

        isValid     : function()        {
          return true;
        },

        beforeRender : function()        {
          //Bind on confirm button click
          this.model = this.options.model;

          //Instancing sections
          var len     = this.model.get("sections").length,i=0;
          var objModel= "";
          var pageContent     = $(this.el).find(".itemView");
          var confirmSection  = $(this.el).find("footer");

          if(confirmSection.length)
            pageContent.css("height", (this.$el.height()-confirmSection.height())+"px");
          else
            pageContent.css("height", this.$el.height()+"px");

          $(this.el).find("h3 .titleBarcontent span").corner("2px");
          $(this.el).find(".accordionView").accordion({collapsible: true, active: 0, autoHeight: false });
          //$(this.el).find(".accordionView").mCustomScrollbar({advanced:{updateOnContentResize: true}});

        }
      })
    }

  });

  // Required, return the module for AMD compliance
  return RegularStep;
});